import AccountSettings from '../components/Account/AccountSettings';
import BatchSubmission from '../components/Account/BatchSubmission';
import CorrectionRequest from '../components/Account/CorrectionRequest';
import MultipleVINReport from '../components/Account/MultipleVINReport';
import RunReport from '../components/Account/RunReport';
import AddEditBillingInformation from '../components/Customer/BillingRate/AddEditBillingInformation';
import AddEditCustomerGroup from '../components/Customer/Customer/AddEditCustomerGroup';
import AddEditCustomer from '../components/Customer/Customer/AddEditCustomer';
import AddEditPortfolio from '../components/Customer/Customer/VXC/AddEditPortfolio';
import AddEditPortfolioForOthers from '../components/Customer/Customer/VXC/AddEditPortfolioForOthers';
import AddPortfolio from '../components/Customer/Customer/VXC/AddPortfolio';
import AddEditLocation from '../components/Customer/Location/AddEditLocation';
import AddEditUser from '../components/Customer/User/AddEditUser';
import Users from '../components/Customer/User/UserList';
import DashBoard from '../components/DashBoard';
import Home from '../components/Home';
import CustomerGroups from '../components/Customer/Customer/CustomerGroupList';
import Customers from '../components/Customer/Customer/CustomerList';
import Locations from '../components/Customer/Location/LocationList';
import MyActivity from '../components/Account/MyActivity';
import ReportManager from '../components/Account/ReportManager';
import Portfolio from '../components/Portfolio/Portfolio';
import GenerateInvoice from '../components/Reporting/GenerateInvoice';
import ChangePassword from '../components/User/ChangePassword';
import LocationSelector from '../containers/LocationSelector';
import ProductSelector from '../containers/ProductSelector';
import Selector from '../containers/Selector';
import VXCReportManager from '../components/VXC/ReportManager';
import DataTestTool from '../components/Account/DataTestTool';
import ViewBillingRates from '../components/Customer/BillingRate/ViewBillingRates';
import DataRetentionSearch from '../components/Account/DataRetentionSearch';

const ComponentMap = {
    AccountSettings,
    AddEditCustomerGroup,
    AddEditCustomer,
    AddEditBillingInformation,
    AddEditPortfolio,
    AddPortfolio,
    AddEditPortfolioForOthers,
    AddEditLocation,
    AddEditUser,
    BatchSubmission,
    ChangePassword,
    CorrectionRequest,
    CustomerGroups,
    Customers,
    DashBoard,
    DataRetentionSearch,
    DataTestTool,
    GenerateInvoice,
    Home,
    Locations,
    LocationSelector,
    MultipleVINReport,
    MyActivity,
    Portfolio,
    ProductSelector,
    Selector,
    ReportManager,
    RunReport,
    Users,
    ViewBillingRates,
    VXCReportManager,
};

export default ComponentMap;


// WEBPACK FOOTER //
// ./src/helpers/ComponentMap.js